import dayjs from "dayjs";
function chartOption(data, series, period, time) {
  return {
    legend: {
      right: 135,
      top: 20,
      inactiveColor: "#9fa0a0",
      textStyle: {
        fontSize: 14,
        color: "#9fa0a0",
      },
      data,
    },
    xAxis: {
      boundaryGap: false,
      type: "category",
      data: time,
      axisLabel: {
        interval: 3, //坐标轴刻度标签的显示间隔
        margin: 40,
        color: "#9FA0A0",
        formatter: function (value) {
          let i;
          switch (period) {
            case "month":
              i = dayjs(value).format("YY年MM月DD日");
              break;
            case "week":
              i = dayjs(value).format("YY年MM月DD日HH时");
              break;
            case "day":
              i = dayjs(value).format("YY年MM月DD日HH时");
              break;
          }
          return i;
        },
      },
      axisLine: {
        onZero: false,
      },
      splitNumber: 3,
    },
    yAxis: {
      axisLabel: {},
      scale: true,
    },
    grid: {
      bottom: "100px",
      left: "2%",
      right: "2%",
    },
    tooltip: {
      trigger: "axis",
    },
    toolbox: {
      show: true,
      orient: "horizontal",
      right: 80,
      top: 15,
      itemSize: 20,
      feature: {
        saveAsImage: {
          show: true,
          icon: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAClBJREFUaEPdW3tQVNcZ/33L045irSGogLyyu6ACqUSt2iZTZzKRrbETTGzUNoltp5JJK75icNrOME2mQY2ofaTYJtHGaNCI6fDY1aS10fpA8RE3QdyliAKWSUUrkIi4j9O5Z++9e/cFd8myYu4/l7Pfd875fvc73/ke50AY5DPS2BEPu+O7DuacTkQZcCKVCGkMGE0AGAAiAmMMX6rtdHYRaVoYWAuBLjnJcSoqWvP37rnJNwYjuiCL6udrlZfHU6TmFwDmAch2wZIeGZYEV3wPEZ1wlhgZnXbn67cWpHaoBaEKsAsoW0ugZQAbASKAMUGFd/3NGHo1hHKHDRvVAO8XsABUE8XWgrFlBIzgXzHMipTnG2ChMKCXiMpBd37b87i+M5DGAwPe2xAdFxO7lYEVyrYo2eQwfoOx8u6+viIsnHzHH2i/gEftbxxLEZFVIMzinaTVK40w/NvHmcM+v6cg67o3aF/A205HjR4fdxiMzRwGJjrorcIJHO3u6JmDZQ/ZlKB9AI+paixnwDLf3dfbiIZ/mwHbuuZnFQYEPKa6oZAx/IkUOxP3o4LNQvCn7rfoaV1+dhjTwdjz//v+5HKlevjf8bUN4xwO1gIglgcNis9yb7epV2OjjM4Fk7ivlnF9o8pcTkTLZI1JmvtqvLdefzx7hQw4ocacbnc6rQAiXMFEIC/mvT178w1XOuslmz2jc8FDHVzD8dXndjCGZ12mqxD6K9Vm2zrnTy3kgO+rOnORiPSyav0arRRiKUJlhV/mK0NaGsOxP2C5Nj8vk8ZWn86MABrDZbtJsVF4UZ/Id/1N1g603upzZ1VDHME5ibIooepUMSO86h0iD1GOg5+lJeDlyRP58Ms/bsHe9k5XKhmGHMvJsI4SqusqAPzAtYOJ+avSr3KbdsEPBX21LhFrdIl8vE3Wq9hoaQ/p+D5xgYf82EPjqo9/BOAR/2mQh5F66cCfp/bWlW//NbpkrNYliYDb8Zq13c+4gTz/wON74vCZ/zCNqz52mQgprsqEEElJaa4YQSn9cAjoqzngZBfgpja8ZmlVVEaGfH4LTaj+120GxChtKPR6dX/3NbqJWKVz2fAmayvKrK0+NjxU84PQRROqD7Nw5rurtALgFI6prKkVmyyXw7ZLCzgpseYjwUMErmQEqnAM8vdV+lSs0oqArVdQ1nRZykPC8qak6kOCsYoRllxuHLL2Km0aVupSuYY3N11GmaVFURsb+vkpueYfLCyfVvS0K3XpWKlNEwG3YLNVSNDCt8QoufoDlw1L+a6c34qr3Dvf7Yf+WML9SBwRi8r2DnTZ7WJo7pkvr9CmQwAtPFuaLqHM0uyZT4vjj4qMxJNJ49He24sPPxOCE9GLfAn5BC9EE2sO8txIEQmLQYb/qrN3BCa1k0fE4uich3mzobsHi07Uc9De/Ct1GVihzRABN2OztdlnvrjISFTMnIbJcaM4bfahI7jae9tvFTyQPIHwUEqNiSkrGfxLyicGvpWOQHRBs0fnPCIDFEAvPnEKXXabR6WkiAN+gPNtbRIAN3nQR0VGoGLmDEwSwQp83zl0BG29t9x8g5BPWiGUWmMMmP3K0qv848mkRGzMzZG5L3R3Y9GJk+hWaHqFTosiGfC/scXaJPMLmn2Xg42Tf3vxvBn72q+qlGBgNkqtqWFyZidnK+59REqPpRDMFasGpi9IFEDneoKuO4Eem53vxkVaAbBW1HATtlitfLxREQLYmZ5gzeexr61dMZ8U6w9ePkqvqRIw8WXMk3/FQdhg2wVJydiY+6AH6MV1x9Fjs6FIp8dyrY7TftdkxVarBSO5Zmd7gF1r/hiVbW0hkUeJj9Jr/hZ0pDU6Ohpdd+70GyEVJCZjQ+43FaC7sKTuGJamZWC5Vi8CtuCtS83YzcGOlnnXms+hsk0RY/vJk4VdvMdud1dNVdbeKKP2/aBs+FdZ2XguLQMnr3diycmj/RpNQdJEbMiZ6gH6yLXPUJjh0nB5sxUPxyd4gT2L/e2t/Y67a8a3MWPsfdjR0oxXGj8Z2HAVHPRATaUi0lKcBkrBgNcp4ZlH5yEuKooPoTW+H/j0UOxfkDgR63Pz5Cmv9d1GfEwsb1/r60N8TIxMe8l8BvvbrrgirwDzC2bW9L0C3qfbZkPeB9X+TzED9Cdt7T5FpCXNHbgSbTUskAXUGSvFv/uvXAuaLs2Z1q8mis2nsb/9iqrxfGVQXzknbe1e5vqeinzYb7DnolsMT8mC643vKYLC/vs/kZSC0pzpfkEXm+uxv73FnY/3M78AzaqQQWd8Twya1MlP+toKcW92yTLQ8a/FwKtB/NEb96g9vuX8TySl+YBeZz7FwUrPQPML9IsKGTKNe4K7h6Cv3S3bsBRhSdmTv3Zj/tOycFmmCr5L9sfvTV+rz8XS9Cw+xo4WC0obzwbVXxjvomGRLEOm8d2g+lNm7S7XLq0ymG40LHYDNu52L1GV/YUOU8fE8/nO3rg2qP5+ZVA5P2XW7gzKD1/IXyILOcm0K2g/GIr6d6Phh4qP/k5QFROaZHxb3qX9lTh5BCZuTQL9guEZN2Dj264ITUH3l2qGmt6Q/yNZhsmmncHNn2XcflMDGu02RSlb8q5eutqf5j8rTzbF9FeFhv3zuzUaOnqD4Tk3YOMOUcMDj8+LeFOMb11kgCvWU/F8mr9UAXi7ih6hZxmsDARYaIrxTbEQr67M8kn+j2UES08aQ49GxYjbZxhkrmzTm8FUIA9TjvEvFUw8alExF8z5P1XDFjaeHNMbqudiwB7KNm0rJoZX1d6N3DurAPq4saonGUpGS891PHW0UvVdTg1hHWUf3JZJDmejHGSIEgZqTxs7AUtSchAXFR2SGpP0QVS6Ufn7fW67g3eumFF//T/8NzXyOzWUxU/Eck2vXwRj+nCeQITCHwcpr+W84YVMDvhB4x+3gFhRGMvDYTvpkNY7AevPGX5ezAHnHPx9WoSTXQAoVvry0l2PQJq4l+gaott2TWSK+bHn/ysf8uYd2FLKGL0kfAApVZQM5p5vM7b+nGFFMbd1CVTeh6WjYY+54nGjXZmXel/u8fZ+w5feHcUikk8alnd7ABYaeQfKFoOxXUPpSsI9tobh6XrD6j1Kb+AhQ55xYymRsLQVN95ly5dKuaITkUu7w7NNpFlfP3c1X8oBAaOkRDPtWyP+CUaug6J79SEy1dd9MQ8lJc7+AQOYdXDj/TaHo540NPEu+Mug8tsA8rU5Ilj2mUeLu7z1pbyK40GbtLckemRczFYCCv0N6l3W8Q4C7hYdRG983t33woWFJer/BUCJfPqBVwo10PyBMRbhMlnffFm6kHqX6Q4iFNbN/WW/2URADStBzza9rHcQrQFjz4AQ7WPW3mVhb4YhpZONATsjGdtwLP/XloG2HFWApUFmGEuSNBoqBugnjLFYv7Gs90m995lPqOjAF0Tsz04HKztpKBFut6l6ggKsHHGW6TczGTkXEjCdAWMAjCHg68KNeokvUEkhSLpwj+wmATcZcAOEY2DYd2JuySlVCL2Y/g9HXqxrn6cx2gAAAABJRU5ErkJggg==",
        },
      },
    },
    series,
  };
}

function getChinese(st) {
  let obj = {
    hpaAbs: "气压(hPa)",
    humidityIn: "室内湿度(%)",
    humidityout: "室外湿度(%)",
    windSpeed: "风速(m/s)",
    windDir: "风向(°)",
    rain: "降雨量(mm)",
    solarRadiation: "太阳辐射(W/m2)",
    uv: "紫外线辐射指数",
  };
  if (st === "tempIn" || st === "tempOut") {
    return "温度(C°)";
  } else {
    return obj[st];
  }
}

export { chartOption, getChinese };
